export const scrollToTop = () => {
  (document?.getElementById?.('__main') || window)?.scrollTo?.({
    top: 0,
    behavior: 'smooth',
  });
};

export const vibrate = (pattern: number | number[]) => {
  if (!window?.navigator?.vibrate) return;
  window.navigator.vibrate(pattern);
};
